// src/services/authService.ts
import api from './api';
import { CheckEmailPayload, CheckOtpPayload, EmployerRegistrationPayload, Enquiry } from './types';

export type ApiResponse<T> = Promise<T>;

export const getVendorDetails = (): ApiResponse<any> => api.get('/auth/me').then(res => res.data);

export const postCheckEmail = (payload: CheckEmailPayload): ApiResponse<any> => api.post('/auth/check-email', payload).then(res => res.data);

export const postCheckOtp = (payload: CheckOtpPayload): ApiResponse<any> => api.post('/auth/check-otp', payload).then(res => res.data);

export const postRegisterEmployer = (payload: EmployerRegistrationPayload): ApiResponse<any> => api.post("/auth/register/employer", payload).then(res => res.data);

export const postEnquiry = (payload: Enquiry): ApiResponse<any> => api.post("/auth/register/enquiry", payload).then(res => res.data);
